"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const styles_1 = require("./styles");
const styling_1 = require("../../../styling");
const Camera_1 = tslib_1.__importDefault(require("../../Icons/Camera"));
const usePosterImage_1 = require("../../Hooks/usePosterImage");
const CarouselSlidePosterImage = (0, mobx_react_lite_1.observer)(({ classes, posterUrl }) => {
    const [isImageError, setIsImageError] = (0, usePosterImage_1.usePosterImage)(posterUrl !== null && posterUrl !== void 0 ? posterUrl : "");
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.posterImageStyles }, "carousel-poster-image");
    const shouldDisplayPosterImage = posterUrl != null && !isImageError;
    if (shouldDisplayPosterImage) {
        return (react_1.default.createElement("img", { className: mergedClasses.image, src: posterUrl, alt: "video-poster", onError: () => setIsImageError(true) }));
    }
    return (react_1.default.createElement("div", { className: mergedClasses.stockImageWrapper },
        react_1.default.createElement(Camera_1.default, { className: mergedClasses.cameraIcon, outline: true })));
});
exports.default = CarouselSlidePosterImage;
//# sourceMappingURL=index.js.map